import type { CSSProperties } from 'react'

// "Sign in with Google" button following Google's brand guidelines, sized to match AppleSignInButton so
// the two read as an equal pair: white background, the official multicolor "G", system font, pill radius.
// We keep our own onClick (the flow routes through Cognito); this is the visual only. `label` should be
// one of Google's localized strings — "Continue with Google" / "Continuar com o Google" /
// "Mit Google fortfahren".
export function GoogleSignInButton({
  onClick,
  disabled,
  label,
  style,
}: {
  onClick: () => void
  disabled?: boolean
  label: string
  style?: CSSProperties
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      className="flex w-full items-center justify-center gap-2 disabled:opacity-50"
      style={{
        height: '3rem',
        borderRadius: '999px',
        background: '#ffffff',
        color: '#000000',
        border: '1px solid #000000',
        fontFamily: '-apple-system, system-ui, "SF Pro Text", "Helvetica Neue", Arial, sans-serif',
        fontSize: '15px',
        fontWeight: 500,
        ...style,
      }}>
      <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.56c2.08-1.92 3.28-4.74 3.28-8.09Z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.56-2.76c-.98.66-2.23 1.06-3.72 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z" />
        <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38Z" />
      </svg>
      {label}
    </button>
  )
}
